import './product-detail.scss';
import Swiper from 'swiper/bundle';
import {A11y, Thumbs} from 'swiper/modules';

class ProductDetail {
    constructor (element) {
        this.$productDetail = element;
        this.$productGalleryItemCount = this.$productDetail.querySelectorAll('[data-product-gallery="count"]');
        this.$productGallerySlider = this.$productDetail.querySelector('[data-product-gallery="slider"]');
        this.$productGalleryThumbs = this.$productDetail.querySelector('[data-product-gallery="thumbs"]');
    }

    initialize () {
        if (this.$productGalleryItemCount.length > 1) {
            this.initGallerySlider();
        }
    }

    initGallerySlider () {
        const thumbnailGallerySlider = new Swiper(this.$productGalleryThumbs , {
            modules: [A11y],
            a11y: false,
            slidesPerView: 3,
            scrollOnFocus: true,
            spaceBetween: 4
        });

        const mainGallerySlider = new Swiper(this.$productGallerySlider, {
            modules: [A11y, Thumbs],
            a11y: true,
            slidesPerView: 1,
            spaceBetween: 4,
            thumbs: {
                swiper: thumbnailGallerySlider
            },
        });

        this.$productGalleryItemCount.forEach((thumbnail, index) => {
            thumbnail.addEventListener('focus', () => {
                mainGallerySlider.slideTo(index);
                this.updateAriaPressed(index);
            });

            thumbnail.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    mainGallerySlider.slideTo(index);
                    this.updateAriaPressed(index);
                }
                if (e.key === 'ArrowRight' && index < this.$productGalleryItemCount.length - 1) {
                    this.$productGalleryItemCount[index + 1].focus();
                    mainGallerySlider.slideTo(index + 1);
                    this.updateAriaPressed(index + 1);
                } else if (e.key === 'ArrowLeft' && index > 0) {
                    this.$productGalleryItemCount[index - 1].focus();
                    mainGallerySlider.slideTo(index - 1);
                    this.updateAriaPressed(index - 1);
                }
            });
        });
    }

    updateAriaPressed(activeIndex) {
        this.$productGalleryItemCount.forEach((thumbnail, index) => {
            if (index === activeIndex) {
                thumbnail.setAttribute('aria-pressed', 'true');
            } else {
                thumbnail.setAttribute('aria-pressed', 'false');
            }
        });
    }
}

export { ProductDetail };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;
    if ($context) {
        const $productDetail = $context.querySelectorAll('[data-product-detail="root"]');

        for (let i = 0; i < $productDetail.length; i++) {
            const productDetail = new ProductDetail($productDetail[i]);
            productDetail.initialize();
        }
    }
});
